// @ts-check
import { acceptHMRUpdate, defineStore } from 'pinia';

/**
 * @import {
 * Articulo,
 * BusquedaAlertaNotificacion,
 * CantidadPorEnvase,
 * ColaVolcado,
 * FamiliaArticulo,
 * LineaProduccion,
 * Partida,
 * PartidaEnPuntoDevolcado,
 * PedidoPlanificadoParaPaletizado,
 * PuntoPaletizado,
 * PuntoVolcado,
 * TipoEnvasadoElementoProduccion,
 * Ubicacion,
 * UsuarioLineaProduccion,
 * VolcadosPorArticuloNumeroSerie,
 * } from '@erpagroapp/types' */

export const useTraceabilityStore = defineStore('traceability', {
  state: () => ({
    /** @type {LineaProduccion | null} */
    lineaSeleccionadaEnVolcado: null,
    /** @type {CantidadPorEnvase[] | null} */
    cantidadesNormalizadasPorEnvaseYProducto: null,
    /** @type {Articulo[] | null} */
    articulosDeTipoEnvase: null,
    /** @type {Ubicacion[] | null} */
    ubicacionesAlmacen: null,
    /** @type {LineaProduccion[] | null} */
    lineasDeProduccion: null,
    /** @type {LineaProduccion | null} */
    lineasDeProduccionDelUsuarioDefinidaEnERP: null,
    /** @type {BusquedaAlertaNotificacion[] | null} */
    criteriosDeBusquedaParaAlertasNotificacionDelUsuario: null,
    paleEnRetrabajoPuntoPaletizadoSeleccionado: null,
    /** @type {LineaProduccion | null} */
    lineaDeProduccionSeleccionada: null,
    /** @type {PuntoVolcado | null} */
    puntoDeVolcadoSeleccionado: null,
    /** @type {PuntoPaletizado | null} */
    puntoDePaletizadoSeleccionado: null,
    unidadLogisticaSeleccionada: null,
    /** @type {ColaVolcado | null} */
    volcadoSeleccionado: null,
    /** @type {FamiliaArticulo | null} */
    familiaArticuloSeleccionada: null,
    /** @type {PedidoPlanificadoParaPaletizado | null} */
    pedidoPlanificadoSeleccionado: null,
    edicionPaleSinPedido: false,
    /** @type {TipoEnvasadoElementoProduccion | null} */
    tipoEnvasadoElementoProduccionSeleccionado: null,
    coleccionMercanciaIncluidaEnPale: null, // TODO USAR CON EL GET NO DIRECTAMENTE CON EL STATE PORQUE TIENE UNA CONDICION / Contiene las cantidades de envases y kilos por partida de los puntos de paletizado que todavía no han generando palé en ERP.
    coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado: null, // TODO USAR CON EL GET NO DIRECTAMENTE CON EL STATE PORQUE TIENE UNA CONDICION
    /** @type {{ PuntoPaletizado: PuntoPaletizado; Pedido: PedidoPlanificadoParaPaletizado } | null} */
    coleccionPedidosAsignadosEnPuntosDePaletizado: null, // TODO USAR CON EL GET NO DIRECTAMENTE CON EL STATE PORQUE TIENE UNA CONDICION
    /** @type {Partida | null} */
    partidaSeleccionada: null,
    /** @type {PartidaEnPuntoDevolcado[] | null} */
    partidasVisualizadas: null,
    /** @type {VolcadosPorArticuloNumeroSerie[] | null} */
    ultimosPalesVolcados: null, // Corresponde a una lista con los ultimos palés volcados en el punto de volcado seleccionado
    /** @type {Record<string, any> | null} */
    paleEnCurso: null, // Corresponde al palé en curso en el punto de paletizado seleccionado
    /** @type {VolcadosPorArticuloNumeroSerie[] | null} */
    datosOrigenPale: null,
    /** @type {UsuarioLineaProduccion[] | null} */
    usuarioLineasProduccion: null,
  }),

  getters: {
    // Devuelve el UsuarioLineaProduccion que esta marcado con el check LineaPorDefecto. ERP solo permite un UsuarioLineaProduccion por defecto.
    getUsuarioLineaProduccionDefecto(state) {
      return state.usuarioLineasProduccion?.find(
        (f) => f.LineaPorDefecto === true,
      ) || null;
    },

    getLineasProduccion(state) {
      /** @type {LineaProduccion[]} */
      const typedArray = [];

      if (state.usuarioLineasProduccion) {
        for (const item of state.usuarioLineasProduccion) {
          if (item.LineaProduccion) {
            typedArray.push(item.LineaProduccion);
          }
        }
      }

      return typedArray;
    },
  },

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useTraceabilityStore, import.meta.webpackHot));
}
